/*
 * @Description: 员工管理
 * @Author: lijinpeng
 * @Date: 2022-04-21 17:28:05
 * @LastEditors: WangYuhan
 */
// 引入api请求方法
import { postGroupUserList } from '@/api/enterprise';
import { roleType, dataPermissionTypes } from '@/utils/dictionary/index';

const storeModuleName = 'employManageModule';

const state = {
  // 筛选项-
  parameters: [
    {
      style: 'input',
      param: 'keyword',
      value: '',
      valueType: 'string',
      label: '姓名',
      placeholder: '请输入姓名/手机号',
      clearable: true,
    },
    {
      style: 'select',
      param: 'roleId',
      value: '',
      valueType: 'string',
      state: 'roleType',
      label: '角色',
      placeholder: '请选择',
      clearable: true,
      filterable: false,
    },
    {
      style: 'select',
      param: 'dataPermissionList',
      value: '',
      valueType: 'string',
      state: 'dataPermissionTypes',
      label: '数据权限',
      placeholder: '请选择',
      clearable: true,
      filterable: false,
      multiple: true,
    },
  ],
  // tabs筛选项
  isSpecialTabs: false,
  // 接口调用参数
  postParams: {
    page: 1,
    size: 20,
  },
  // 列表data数据
  listData: {
    list: [],
    tableHeadList: [
      {
        label: '姓名',
        prop: 'name',
        width: 200,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-names',
      },
      {
        label: '手机号',
        prop: 'mobile',
        width: 200,
        checked: 1,
        sortable: true,
      },
      {
        label: '角色',
        prop: 'roleIdList',
        width: 200,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-role',
      },
      {
        label: '数据权限',
        prop: 'status',
        width: 200,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-status',
      },
      {
        label: '操作',
        prop: '',
        width: 100,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-operate',
      },
    ],
  },
  roleType, // 角色列表
  dataPermissionTypes, // 数据权限列表
};

// getters
const getters = {};

// actions
const actions = {
  // 获取列表数据
  getList: async context => {
    try {
      const params = {};
      context.state.parameters.forEach(item => {
        if (item.style !== 'date-picker' && item.value) {
          params[item.param] = item.value;
        }
      });
      if (params.dataPermissionList && params.dataPermissionList.length) {
        params.dataPermissionList = params.dataPermissionList.join(',');
      }
      const { data } = await postGroupUserList(Object.assign({}, params, context.state.postParams));
      context.commit('updateState', {
        key: 'listData',
        value: Object.assign({}, context.state.listData, data),
      });
    } catch (error) {
      console.error(error);
    }
  },
};

// mutations
const mutations = {
  // 重置所有状态
  initFilter(state) {
    state.postParams = {
      page: 1,
      size: 20,
    };
    state.parameters.forEach(item => {
      if (item.isFixed) {
        return;
      }
      if (item.style !== 'date-picker') {
        if (item.multiple) {
          item.value = '';
        } else {
          item.value = '';
        }
      }
      if (item.style === 'date-picker') {
        item.value = [];
      }
    });
  },
  // 更新state数据
  updateState(state, { key, value }) {
    state[key] = value;
  },
  // 更新列表参数数据
  updatePostParams(state, payload) {
    state.postParams = Object.assign({}, state.postParams, payload);
  },
  // 根据index更新value
  updateValueFromIndex(state, payload) {
    state.parameters[payload.index].value = payload.value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
